export default {
  methods: {
    showErrorDialog(e) {
      // eslint-disable-next-line no-console
      console.log('errorDialog:', e);

      let title = this.$t('errors.default.title');
      let message = this.$t('errors.default.message', { error: e.message });

      // No connection error
      if (e.message === 'Network Error') {
        title = this.$t('errors.networkError.title');
        message = this.$t('errors.networkError.message');
      }

      // Check for error messages from API
      // @todo translations
      if (e.response && e.response.data && e.response.data.messages) {
        message = e.response.data.messages;
      }
      // Show error based on error code from backend
      else if (e.response && e.response.data && e.response.data.code) {
        title = this.$t(`errors.code.${e.response.data.code}.title`);
        message = this.$t(`errors.code.${e.response.data.code}.message`, { error: e.response.data.error });

        if (e.response.data.message) {
          message = `${message} (${e.response.data.message})`;
        }
      }

      this.$q.dialog({
        title,
        message,
      });
    },
  },
};
